import { Menu, MenuItem, Tooltip } from "@mui/material";
import { useState } from "react";

import TextButton from "../TextButton";
import type { WhiteDropdownMenuOptions } from "../WhiteDropdownMenu";
import styles from "./style.module.scss";

interface TextBtnDropdown {
    btnText: string;
    btnStyle?: React.CSSProperties;
    menuOptions: WhiteDropdownMenuOptions[];
}

const TextBtnDropdown = ({ btnText, btnStyle, menuOptions }: TextBtnDropdown) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e: any, option: any) => {
        e.stopPropagation();
        option.action();
        setAnchorEl(null);
    };

    return (
        <>
            <TextButton text={btnText} handleClick={handleClick} style={btnStyle} />
            <Menu
                id="menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                className={styles["insert-variable-menu"]}
                // elevation={0}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                {menuOptions.map((option) => {
                    return (
                        <Tooltip title={option?.tooltip} style={{ cursor: "pointer" }} key={option.id}>
                            <div>
                                <MenuItem
                                    key={option.id}
                                    onClick={(e: any) => handleClose(e, option)}
                                    disabled={option.disabled}
                                    sx={{
                                        fontSize: "13px",
                                        fontFamily: "Poppins",
                                        borderBottom: "1px solid rgb(234, 234, 234)",
                                    }}
                                >
                                    {option.name}
                                </MenuItem>
                            </div>
                        </Tooltip>
                    );
                })}
            </Menu>
        </>
    );
};

export default TextBtnDropdown;
